import { render, staticRenderFns } from "./FormatReferenceTreeEditDialog.vue?vue&type=template&id=32348a47&scoped=true&"
import script from "./FormatReferenceTreeEditDialog.vue?vue&type=script&lang=ts&"
export * from "./FormatReferenceTreeEditDialog.vue?vue&type=script&lang=ts&"
import style0 from "./FormatReferenceTreeEditDialog.vue?vue&type=style&index=0&id=32348a47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32348a47",
  null
  
)

export default component.exports